module.exports = __webpack_public_path__ + "static/media/pencil-black.9269e153.svg";